import * as React from "react";
import * as ReactDOM from "react-dom";
import {Provider} from "react-redux";
import store from "src/store/store";
import App from "./components/view/App";
import "./styles/index.css";

ReactDOM.render(
    <Provider store={store}>
        <App/>
    </Provider>,
    document.getElementById('root') as HTMLElement
);



// WEBPACK FOOTER //
// ./src/index.tsx